import { render } from "./PerformanceProductTableTotal.vue?vue&type=template&id=66901330&scoped=true"
import script from "./PerformanceProductTableTotal.vue?vue&type=script&lang=js"
export * from "./PerformanceProductTableTotal.vue?vue&type=script&lang=js"

import "./PerformanceProductTableTotal.vue?vue&type=style&index=0&id=66901330&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66901330"]])

export default __exports__